import { SET_USER_PROPERTIES, SET_CHANGE_HOLDER_PROPERTY_MODAL, SET_USER_PROPERTIES_RELOAD } from '@/redux/mutations';

export const initialState = {
    properties: [],
    reloadProperties: true,
    changeHolderModalOpen: false
};

const userPropertiesReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SET_USER_PROPERTIES:
            return {
                ...state,
                properties: actions.payload,
                reloadProperties: false
            };
        case SET_USER_PROPERTIES_RELOAD:
            return {
                ...state,
                reloadProperties: actions.payload
            };
        case SET_CHANGE_HOLDER_PROPERTY_MODAL:
            return {
                ...state,
                changeHolderModalOpen: actions.payload.open
            };
        default:
            return state;
    }
};

export default userPropertiesReducer;
